export default __webpack_public_path__ + "static/media/yellow_rub_cut.d9646ffa.png";